// Zentrale Konfiguration fuer die Geraeteverwaltung -- analog DEVICE_FIELD_CONFIG-Idee
// aus der Planungs-Notiz. Presets leben bewusst hier im Frontend (nicht als DB-Tabelle),
// damit neue Presets ohne Backend-Migration ergaenzt werden koennen.
import {
  Monitor, Server, Printer, ScanLine, Smartphone, Phone, PhoneCall,
  Radio, Wifi, Router, HardDrive, Cog, Globe, Box, BatteryCharging,
  Tv, AppWindow, Camera, Network, Shield,
} from 'lucide-react';

export const DEVICE_TYPES = [
  { value: 'computer',     label: 'Computer',            icon: Monitor },
  { value: 'phone_dect',   label: 'DECT-Telefon',        icon: Phone },
  { value: 'printer',      label: 'Drucker',             icon: Printer },
  { value: 'firewall',     label: 'Firewall',            icon: Shield },
  { value: 'camera',       label: 'Kamera',               icon: Camera },
  { value: 'machine',      label: 'Maschine',            icon: Cog },
  { value: 'phone_mobile', label: 'Mobiltelefon',        icon: Smartphone },
  { value: 'monitor',      label: 'Monitor',             icon: Tv },
  { value: 'nas',          label: 'NAS',                 icon: HardDrive },
  { value: 'network',      label: 'Netzwerkgeraet',      icon: Router },
  { value: 'repeater',     label: 'Repeater',            icon: Radio },
  { value: 'scanner',      label: 'Scanner',             icon: ScanLine },
  { value: 'server',       label: 'Server',              icon: Server },
  { value: 'software',     label: 'Software',            icon: AppWindow },
  { value: 'other',        label: 'Sonstiges',           icon: Box },
  { value: 'switch',       label: 'Switch',              icon: Network },
  { value: 'phone_desk',   label: 'Tischtelefon',        icon: PhoneCall },
  { value: 'usv',          label: 'USV',                 icon: BatteryCharging },
  { value: 'website',      label: 'Website',             icon: Globe },
  { value: 'wifi_ap',      label: 'WLAN Access Point',   icon: Wifi },
];

export const SWITCH_MANAGED_TYPES = [
  { value: 'managed',   label: 'Managed' },
  { value: 'unmanaged', label: 'Unmanaged' },
];

export const PRINTER_SUBTYPES = [
  { value: 'laser_bw',    label: 'Laser Schwarzweiss' },
  { value: 'laser_color', label: 'Laser Farbe' },
  { value: 'inkjet',      label: 'Tintenstrahl' },
  { value: 'label',       label: 'Etikettendrucker' },
  { value: 'dot_matrix',  label: 'Nadeldrucker' },
  { value: '3d_printer',  label: '3D-Drucker' },
];

export const CONNECTION_TYPES = [
  { value: 'lokal',    label: 'Lokal' },
  { value: 'usb',      label: 'USB' },
  { value: 'netzwerk', label: 'Netzwerk' },
];

// Vorgeschlagene Consumables je Drucker-Subtyp. Bewusst nur Vorschlaege --
// im UI kann trotzdem jederzeit ein freier/individueller Eintrag angelegt werden
// (sowohl-als-auch-Entscheidung, siehe Vault-Notiz). 3d_printer hat bewusst
// keine Presets (kein Verbrauchsmaterial-Tracking).
export const CONSUMABLE_PRESETS = {
  laser_bw: [
    { name: 'Toner Schwarz', consumable_type: 'toner_black' },
    { name: 'Trommel', consumable_type: 'drum' },
    { name: 'Fixiereinheit', consumable_type: 'fuser' },
  ],
  laser_color: [
    { name: 'Toner Schwarz', consumable_type: 'toner_black' },
    { name: 'Toner Cyan', consumable_type: 'toner_cyan' },
    { name: 'Toner Magenta', consumable_type: 'toner_magenta' },
    { name: 'Toner Gelb', consumable_type: 'toner_yellow' },
    { name: 'Trommel', consumable_type: 'drum' },
    { name: 'Transfer-Kit', consumable_type: 'transfer_kit' },
  ],
  inkjet: [
    { name: 'Patrone Schwarz', consumable_type: 'cartridge_black' },
    { name: 'Patrone Cyan', consumable_type: 'cartridge_cyan' },
    { name: 'Patrone Magenta', consumable_type: 'cartridge_magenta' },
    { name: 'Patrone Gelb', consumable_type: 'cartridge_yellow' },
  ],
  label: [
    { name: 'Etiketten-Rolle', consumable_type: 'label_roll' },
    { name: 'Farbband', consumable_type: 'ribbon' },
  ],
  dot_matrix: [
    { name: 'Farbband', consumable_type: 'ribbon' },
  ],
  '3d_printer': [],
};

export const deviceTypeInfo = (value) => DEVICE_TYPES.find(t => t.value === value) || { value, label: value || 'Unbekannt', icon: Box };
export const printerSubtypeLabel = (value) => (PRINTER_SUBTYPES.find(t => t.value === value) || {}).label || value;
export const connectionTypeLabel = (value) => (CONNECTION_TYPES.find(t => t.value === value) || {}).label || value;
